import React from 'react';
import { TagIcon } from '../components/icons/TagIcon';
import { FolderIcon } from '../components/icons/FolderIcon';
import { CreditCardIcon } from '../components/icons/CreditCardIcon';
import { GlobeIcon } from '../components/icons/GlobeIcon';
import { BuildingIcon } from '../components/icons/BuildingIcon';
import { SettingsIcon } from '../components/icons/SettingsIcon';
import { UserIcon } from '../components/icons/UserIcon';
import { MergeIcon } from '../components/icons/MergeIcon';
import { ManageableType } from '../contexts/SettingsContext';
import { LogIcon } from '../components/icons/LogIcon';
import { CloudIcon } from '../components/icons/CloudIcon';
import { CameraIcon } from '../components/icons/CameraIcon';
import { MagicIcon } from '../components/icons/MagicIcon';
import { ApiTestIcon } from '../components/icons/ApiTestIcon';

type SectionType = 'colored' | 'simple' | 'config' | 'users' | 'custom';
export type DataManagementViewId = ManageableType | 'businesses' | 'products';
export type AppSettingsViewId = 'api' | 'users' | 'export' | 'logging' | 'scanner' | 'prompts' | 'touchTest';

export interface SectionConfig {
    id: string; // DataManagementViewId or AppSettingsViewId
    navLabel: string;
    managerTitle: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    type: SectionType;
    isAddable: boolean;
    isDeletable: boolean;
    hasColor: boolean;
}

export const dataManagementSections: SectionConfig[] = [
    {
        id: 'tags',
        navLabel: 'Štítky',
        managerTitle: 'Správa štítků',
        icon: TagIcon,
        type: 'colored',
        isAddable: true,
        isDeletable: true,
        hasColor: true,
    },
    {
        id: 'categories',
        navLabel: 'Kategorie',
        managerTitle: 'Správa kategorií',
        icon: FolderIcon,
        type: 'colored',
        isAddable: true,
        isDeletable: true,
        hasColor: true,
    },
    {
        id: 'paymentMethods',
        navLabel: 'Způsoby platby',
        managerTitle: 'Správa způsobů platby',
        icon: CreditCardIcon,
        type: 'colored',
        isAddable: true,
        isDeletable: true,
        hasColor: true,
    },
    {
        id: 'currencies',
        navLabel: 'Měny',
        managerTitle: 'Správa měn',
        icon: GlobeIcon,
        type: 'simple',
        isAddable: true,
        isDeletable: true,
        hasColor: false,
    },
    {
        id: 'businesses',
        navLabel: 'Dodavatelé',
        managerTitle: 'Správa podniků',
        icon: BuildingIcon,
        type: 'simple',
        isAddable: true,
        isDeletable: false,
        hasColor: false,
    },
    {
        id: 'products',
        navLabel: 'Slučování produktů',
        managerTitle: 'Slučování názvů produktů',
        icon: MergeIcon,
        type: 'custom',
        isAddable: false, // Custom component handles its own logic
        isDeletable: false,
        hasColor: false,
    },
];

export const appSettingsSections: SectionConfig[] = [
     {
        id: 'api',
        navLabel: 'Připojení k API',
        managerTitle: 'Nastavení API připojení',
        icon: CloudIcon,
        type: 'custom',
        isAddable: false,
        isDeletable: false,
        hasColor: false,
    },
     {
        id: 'users',
        navLabel: 'Uživatelé',
        managerTitle: 'Správa uživatelů',
        icon: UserIcon,
        type: 'users',
        isAddable: true,
        isDeletable: true,
        hasColor: false,
    },
    {
        id: 'prompts',
        navLabel: 'AI Prompty',
        managerTitle: 'Správa AI promptů',
        icon: MagicIcon,
        type: 'custom',
        isAddable: false,
        isDeletable: false,
        hasColor: false,
    },
    {
        id: 'export',
        navLabel: 'Nastavení exportu',
        managerTitle: 'Nastavení sloupců pro CSV export',
        icon: SettingsIcon,
        type: 'config',
        isAddable: false,
        isDeletable: false,
        hasColor: false,
    },
    {
        id: 'scanner',
        navLabel: 'Skenování',
        managerTitle: 'Nastavení skenování a kamery',
        icon: CameraIcon,
        type: 'custom',
        isAddable: false,
        isDeletable: false,
        hasColor: false,
    },
    {
        id: 'logging',
        navLabel: 'Logování',
        managerTitle: 'Nastavení logování v prohlížeči',
        icon: LogIcon,
        type: 'custom',
        isAddable: false,
        isDeletable: false,
        hasColor: false,
    },
    {
        id: 'touchTest',
        navLabel: 'Test dotyku',
        managerTitle: 'Testování Drag & Drop na dotykových zařízeních',
        icon: ApiTestIcon,
        type: 'custom',
        isAddable: false,
        isDeletable: false,
        hasColor: false,
    },
];
